import { useState, useCallback, useEffect } from 'react';

const useChallenge = ({ integrationId, GeckoIntegrations }) => {
  const [isFetchingNextChallenge, setIsFetchingNextChallenge] = useState(false);
  const [nextChallenge, setNextChallenge] = useState(null);
  const [
    isSubmittingChallengeResponse,
    setIsSubmittingChallengeResponse,
  ] = useState(false);
  const [submissionErrors, setSubmissionErrors] = useState([]);
  const [value, setValue] = useState(null);

  const fetchNextChallenge = useCallback(async () => {
    setIsFetchingNextChallenge(true);
    try {
      const response = await GeckoIntegrations.getNextChallenge(integrationId);
      if (response.success === true) {
        setSubmissionErrors([]);
        setNextChallenge(response.data.challenge);
        setValue(null);
      } else {
        setSubmissionErrors(response.errors);
      }
    } catch (error) {
      console.error(error);
      setSubmissionErrors([
        {
          code: 500,
          title: 'Unknown error',
          detail: 'An unknown error occured getting the next challenge',
        },
      ]);
    }
    setIsFetchingNextChallenge(false);
  }, [
    integrationId,
    GeckoIntegrations,
    setIsFetchingNextChallenge,
    setNextChallenge,
    setSubmissionErrors,
  ]);

  const submitChallengeResponse = useCallback(
    async (submissionValue) => {
      setIsSubmittingChallengeResponse(true);
      try {
        const response = await GeckoIntegrations.submitChallengeResponse(
          integrationId,
          nextChallenge,
          submissionValue || value
        );
        if (response.success === true) {
          setSubmissionErrors([]);
          fetchNextChallenge();
        } else {
          setSubmissionErrors(response.errors);
        }
      } catch (error) {
        console.error(error);
        setSubmissionErrors([
          {
            code: 500,
            title: 'Unknown error',
            detail: 'An unknown error occured submitting the response',
          },
        ]);
      }
      setIsSubmittingChallengeResponse(false);
    },
    [
      integrationId,
      GeckoIntegrations,
      nextChallenge,
      value,
      setValue,
      setIsSubmittingChallengeResponse,
      setSubmissionErrors,
      fetchNextChallenge,
    ]
  );

  useEffect(() => {
    fetchNextChallenge();
  }, [fetchNextChallenge]);

  return {
    value,
    setValue,
    isFetchingNextChallenge,
    nextChallenge,
    isSubmittingChallengeResponse,
    submitChallengeResponse,
    submissionErrors,
  };
};

export default useChallenge;
